import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const initGSAPInView = () => {

	const elements = document.querySelectorAll('.scrolled');

	if (!elements.length) return;

	elements.forEach((el) => {
		ScrollTrigger.create({
			trigger: el,
			start: "top center",
			end: "bottom top",
			onEnter: () => el.classList.add('inView'),
			onLeave: () => el.classList.remove('inView'),
			onEnterBack: () => el.classList.add('inView'),
			onLeaveBack: () => el.classList.remove('inView'),
		});
	});

	const map = document.querySelector('.map img');

	if (!map) return;

	gsap.set(map, {
		opacity: 0,
		scale: 0.95,
		y: 0
	});

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: map,
			start: "top 80%",
			end: "bottom 70%",
			toggleActions: "play reverse play reverse",
			scrub: 2,
		}
	});
	tl.to(map, {
		opacity: 1,
		scale: 1,
		y: 0,
		duration: 0.8,
		ease: "power2.inOut"
	});


}

export { initGSAPInView };
